export default __webpack_public_path__ + "static/media/Serpentscale Belt.7691e652.jpg";